import api from '../services/config/api';
import { objToQuery } from 'utils/query';
import { getItemStorage } from './storage';
import { tokenKey } from 'constants/storage';
export interface IGetBudgetControlStatusList {
  servicos: number;
  status: string;
  total: number;
}

export const getBudgetControlStatusList = (query: string) =>
  api.get<IGetBudgetControlStatusList[]>(
    `/controle-orcamentario/controle-por-status${query[0] === '?' || !query ? query : `?${query}`}`,
  );

export interface IGetBudgetControlServiceTotal {
  totalServicos: number;
  valorInvestido: number;
}

export const getBudgetControlServiceTotal = (query: string) =>
  api.get<IGetBudgetControlServiceTotal>(
    `/controle-orcamentario/total-servicos${query[0] === '?' || !query ? query : `?${query}`}`,
  );

export interface IGetBudgetControlService {
  client: {
    id: number;
    name: string;
  };
  demanda: string;
  id: number;
  status: string;
  valor: number;
}

export interface IGetBudgetControlServices {
  content: IGetBudgetControlService[];
  totalPages: number;
}

export const getBudgetControlServices = (query: string) =>
  api.get<IGetBudgetControlServices>(
    `/controle-orcamentario/filter${query[0] === '?' || !query ? query : `?${query}`}`,
  );

export interface IGetBudgetControlHoursResume {
  contratado: number;
  expiracao: string;
}

export const getBudgetControlHoursResume = (query: string) =>
  api.get<IGetBudgetControlHoursResume>(
    `/controle-orcamentario/contratacao${query[0] === '?' || !query ? query : `?${query}`}`,
  );

export interface IGetBudgetControlHoursProgress {
  contratada: string;
  consumida: string;
  saldo: string;
}
export const getBudgetControlHoursProgress = (query: string) =>
  api.get<IGetBudgetControlHoursProgress>(
    `/controle-orcamentario/barra-progresso${query[0] === '?' || !query ? query : `?${query}`}`,
  );

export interface IAddHoursBank {
  client: {
    id: number;
  };
  dataExpiracao: string;
  quantidade: string;
  valor: number;
}

export const addHoursBank = (data: IAddHoursBank) => api.post('/banco-horas', data);

export interface IReportGen {
  idCliente?: number;
  dataInicial?: string;
  dataFinal?: string;
  periodoInicial: string;
  periodoFinal: string;
}

export const generateReport = (data: IReportGen) =>
  new Promise<{
    headers: Headers;
    data: Blob;
  }>((resolve, reject) => {
    let headers = null as null | Headers;

    fetch(`${api.defaults.baseURL}/controle-orcamentario/export-excel?${objToQuery(data)}`, {
      headers: {
        Authorization: `Bearer ${getItemStorage(tokenKey)}`,
      },
    })
      .then(e => {
        headers = e.headers;
        return e.blob();
      })
      .then(e => {
        resolve({ headers: headers as Headers, data: e });
      })
      .catch(reject);
  });

export interface IGetBudgetControlServiceById {
  demanda: string;
  autorDemanda: string;
  areaDemandante: string;
  createdAt: string;
  descricaoTrabalho: string;
  valor: number;
  horas: number;
  lawyer: {
    name: string;
    id: number;
  };
  historico: {
    data: string;
    id: number;
    status: string;
  }[];
  prazo: string;
}

export const getBudgetControlServiceById = (serviceId: number) =>
  api.get<IGetBudgetControlServiceById>(`/controle-orcamentario/${serviceId}`);
